import useDeviceOnlineStatus from '../../../../API/hooks/devices/useDeviceOnlineStatus';
import S from './BroadcastQueueStyles';

const PLACEHOLDER = '—';

type Props = {
  fleetId: string | null;
  deviceId: string;
  fallback?: string;
};

export default function DeviceStatusCell({
  fleetId,
  deviceId,
  fallback = PLACEHOLDER,
}: Props): JSX.Element {
  const { data, isLoading, isError } = useDeviceOnlineStatus(fleetId, deviceId, Boolean(fleetId));

  const showOnlineStatus = Boolean(fleetId) && !isLoading && !isError && data != null;
  const isOffline = showOnlineStatus && data != null && !data.isOnline;
  let text = fallback;
  if (isError) {
    text = 'Device Not Found';
  } else if (showOnlineStatus && data != null) {
    text = data.isOnline ? 'Online' : 'Offline';
  }

  return (
    <S.DeviceStatusCell $isOffline={isOffline}>
      {text}
    </S.DeviceStatusCell>
  );
}
